import { useFetcher, useRouteLoaderData } from 'react-router'
import { type loader as rootLoader } from '#app/root.tsx'
import { InteractiveGradientBlob } from './marketing/interactive-gradient-circle.tsx'
import { EmailSpotlight } from './ui/email-spotlight.tsx'

export function PreLaunchPage() {
	const fetcher = useFetcher()
	const isSubmitting = fetcher.state === 'submitting'
	const data = fetcher.data as { success?: boolean; message?: string; error?: string } | undefined
	const isSuccess = data?.success

	// This form submits programmatically (not a real <Form>), so the hidden
	// <HoneypotInputs /> fields aren't included automatically — merge them in
	// from the root loader's honeypot props so checkHoneypot() sees them.
	const honeyProps = useRouteLoaderData<typeof rootLoader>('root')?.honeyProps

	const handleSubmit = (email: string) => {
		void fetcher.submit(
			{
				email,
				...(honeyProps
					? {
							[honeyProps.nameFieldName]: '',
							...(honeyProps.validFromFieldName
								? {
										[honeyProps.validFromFieldName]:
											honeyProps.encryptedValidFrom ?? '',
									}
								: {}),
						}
					: {}),
			},
			{ method: 'POST', action: '/resources/newsletter/subscribe' },
		)
	}

	return (
		<div className="relative flex min-h-screen flex-col items-center justify-end overflow-hidden bg-[#f7f1e2]">
			{/* Subtle animated gradient blob - same style as hero */}
			<div
				className="pointer-events-none absolute inset-0"
				style={{
					maskImage: 'radial-gradient(ellipse at center, black 0%, black 40%, transparent 70%)',
					WebkitMaskImage: 'radial-gradient(ellipse at center, black 0%, black 40%, transparent 70%)',
				}}
			>
				<InteractiveGradientBlob
					containerClassName="h-full"
					firstColor="246, 146, 30"
					secondColor="235, 0, 139"
					pointerColor="255, 91, 142"
					size="60%"
					interactive={true}
				/>
			</div>

			{/* Content - positioned at bottom */}
			<div className="relative z-10 w-full px-6 pb-16 md:pb-24">
				<div className="mx-auto max-w-lg">
					<EmailSpotlight
						placeholder="Blijf op de hoogte"
						buttonText="Aanmelden"
						onSubmit={handleSubmit}
						isSubmitting={isSubmitting}
						isSuccess={isSuccess}
					/>
					{data?.error && (
						<p className="mt-3 text-center text-sm text-red-600">{data.error}</p>
					)}
				</div>
			</div>
		</div>
	)
}
